import { useEffect } from 'react';
import type {
  MeetingOpenedDocument,
  MeetingPageResponse,
} from '@wundo/shared/meetingPage.ts';
import { reportMeetingDocumentOpened } from '@/lib/meetingPage.ts';
import type { MeetingPanel } from './meetingPanel.ts';

/**
 * Tells the server which document the user is reading, if the open tab holds
 * one. Keyed on the document rather than the page, so polling never says it
 * twice; the server counts it once a day.
 */
export function useReportOpenedDocument(
  userId: string | undefined,
  meetingId: string,
  panel: MeetingPanel,
  page: MeetingPageResponse | undefined,
): void {
  const shownDocument = shownDocumentOf(panel, page);
  useEffect(() => {
    if (!userId || !shownDocument) return;
    void reportMeetingDocumentOpened(userId, meetingId, shownDocument);
  }, [userId, meetingId, shownDocument]);
}

function shownDocumentOf(
  panel: MeetingPanel,
  page: MeetingPageResponse | undefined,
): MeetingOpenedDocument | null {
  if (panel === 'prep') {
    const hasPrep = (page?.prep?.content.text.trim().length ?? 0) > 0;
    return hasPrep ? 'prep' : null;
  }
  return page?.report != null ? 'report' : null;
}
